import { Injectable } from '@angular/core';
import { WindowRefService } from '../window/window-ref.service';
import {
  conversionId,
  infinityTagId,
  ConversionTypeEnum,
} from './kenshoo.constant';

/**
 * Provides kenshoo javascript functionality
 *
 * Before using this service, ensure that the kenshoo script
 * has been put inside targeted application html template
 * @see kenshoo.com
 */
@Injectable({
  providedIn: 'root',
})
export class KenshooService {
  private _conversionId: string = conversionId;
  private _infinityTagId: string = infinityTagId;

  constructor(private _windowRefService: WindowRefService) {}

  // TODO: implement load global tag script function here, currently it is a bit difficult to implement

  loadInfinityTagScript() {
    // global variable is present = script was already loaded
    if (this._getKenshoo()) {
      return;
    }

    const scriptSrc = `https://services.xg4ken.com/js/kenshoo.js?cid=${this._infinityTagId}`;

    // prepare script elem
    const scriptElem = document.createElement('script');
    scriptElem.id = 'kenshoo-infinity-tag';
    scriptElem.innerHTML = '';
    scriptElem.src = scriptSrc;
    scriptElem.async = true;
    scriptElem.defer = true;

    // add script to header
    document.getElementsByTagName('head')[0].appendChild(scriptElem);
  }

  trackConversion(
    conversionType: ConversionTypeEnum,
    extraParams: { [key: string]: any } = {}
  ) {
    // the values in the first params coming from Kenshoo and should always same and never be edited.
    this._getKenshoo().trackConversion(
      this._conversionId,
      this._infinityTagId,
      {
        conversionType,
        ...extraParams,
      }
    );
  }

  /**
   * This global variable exists if infinity tag script is loaded
   */
  private _getKenshoo() {
    return this._windowRefService.nativeWindow['kenshoo'];
  }
}
